/* eslint-disable no-param-reassign */
import * as logger from 'loglevel';
import { getFares } from '../../../_integrations/everymundo/breakingDeals';
import { isSSR } from '@front10/utils';
import { withCommonPreloads } from './commons/commonPreloads';

const preloadCustomPropsExecute = (cmpConfig, clientPromises, ssrPromises) => {
  return new Promise((resolve, reject) => {
    const {
      containerConfig: {
        settings: { integrationSettings, prePopulation, meta, pageContext }
      },
      name,
      simulateSSR
    } = cmpConfig;

    let promises = [];
    if (!isSSR(simulateSSR)) {
      promises = clientPromises;
    } else {
      ssrPromises.push(getFares(prePopulation, integrationSettings, meta, pageContext));
      promises = ssrPromises;
    }

    Promise.all(promises)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then(([_, data]) => {
        cmpConfig.containerConfig.settings.getBreakingDeals = getFares;
        cmpConfig.containerConfig.settings.initialData = data;
        resolve(cmpConfig);
      })
      .catch((err) => {
        logger.error(`PRELOAD_CUSTOM_PROPS: ${name}`, err);
        reject(err);
      });
  });
};

const preloadCustomProps = (cmpConfig) => {
  // HOC For all Common Preload Logic
  return withCommonPreloads(preloadCustomPropsExecute, cmpConfig);
};

export default preloadCustomProps;
